import PersonAchievementEvent from './PersonAchievementEvent';

export default PersonAchievementEvent;
